angular.module("app").directive("scatterChartModal", () => {
  let link = (scope) => {
    scope.allData = {
      data: scope.data,
      index: scope.index,
    };

    scope.selectedData = scope.data[scope.index];

    scope.LeftButtonHandler = () => {
      let index = scope.allData.index;
      if (index > 0) {
        index--;
      }
      scope.allData.index = index;
      scope.selectedData = scope.allData.data[index];
    };

    scope.RightButtonHandler = () => {
      try {
        let index = scope.allData.index;
        if (index < scope.allData.data.length - 1) {
          index++;
        }
        scope.allData.index = index;
        scope.selectedData = scope.allData.data[index];
      } catch (e) {}
    };

    scope.closeClickHandler = () => {
      scope.closefunction();
    };

    scope.shareFacebook = (url) => {
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + url);
    };

    scope.shareTwitter = (url) => {
      window.open("https://twitter.com/home?status=" + url);
    };

    scope.sharePinterest = (url) => {
      window.open("https://pinterest.com/pin/create/button/?url=" + url);
    };

    scope.shareGooglePlus = (url) => {
      window.open("https://plus.google.com/share?url=" + url);
    };

    // dummy data
    scope.data = {
      search: "yellow",
      colorName: "yellow gum",
      source: "crowdsource",
      color: {
        hex: "yellow",
        R: 179,
        G: 73,
        B: 83
      }
    }
  };

  return {
    restrict: "E",
    templateUrl: "app/directives/scatter3dChart/scatterChartModalView.html",
    link: link,
    scope: {
      data: "=",
      index: "=",
      searchWord: "=",
      onClose: "&",
      closefunction: "=",
    },
  };
});
